<template>
    <div class ="box1">
        <div class="title">{{award_info.name}}</div>
        <div class="info">{{award_info.desc}}</div>
        <button v-if="JSON.stringify(address) === '{}'" @click="goRouter('AddressInfo')" class="btn">添加地址</button>
        <div v-else>
            <div class="site_Info">
                <div class="person_info">
                    <div class="name">{{address.name}}</div>
                    <div class="phone">{{address.mobile}}</div>
                </div>
                <div class="address">{{address.province}}{{address.city}}{{address.district}}{{address.full_address}}</div>
            </div>
            <div class="parcel_info">
                运单号： <span ref="express_no">{{express_no || ''}}</span>
                <van-image
                    v-if="express_no !== '' && express_no"
                    @click="copyExpressNo"
                    class="image"
                    width="8px"
                    height="9.5px"
                    :src="require('../images/copy.png')"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['address', 'express_no', 'award_info', 'id'],
  methods: {
    goRouter (path) {
      this.$router.push({
        name: `${path}`,
        params: { id: this.id }
      })
    },
    copyExpressNo () {
      const random = this.$refs.express_no.innerHTML
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', random)
      input.setAttribute('create', 1)
      input.select()
      document.execCommand('Copy')
      const list = document.getElementsByTagName('input')
      const inputList = Array.prototype.slice.call(list)
      inputList.forEach((item) => {
        if (item.getAttribute('create'))document.body.removeChild(item)
      })
      this.$toast('运单号已复制')
    }
  }
}
</script>

<style lang="scss" scoped>
.box1 {
    width: 350px;
    // height: 150px;
    border-radius: 10px;
    background-color: #fff;
    font-size: 12px;
    overflow: hidden;
    .site_Info {
        width: 312px;
        // height: 68.5px;
        border-top: 1px solid #EEEEEE;
        border-bottom: 1px solid #EEEEEE;
        margin: 16.5px auto;
        .person_info {
            display: flex;
            margin: 16.5px 0 11.5px 0;
            .name {
                font-size: 14px;
                font-weight: 500;
                color: #333333;
                margin-right: 5.5px;
            }
            .phone {
                margin-top: 2px;
            }
        }
        .address {
            margin-bottom: 16px;
        }
    }
    .parcel_info {
        padding: 0 0 17.5px 22px;
        .image {
            margin-left: 3px;
        }
    }
    .title {
        margin: 24px 0 16px 19.5px ;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
    }
    .info {
        margin-left: 19.5px;
        color: #666666;
        font-size: 14px;
    }
    .btn {
        width: 100px;
        height: 30px;
        background: #5EC8A1;
        border-radius: 15px;
        border: none;
        font-size: 14px;
        color: #fff;
        font-family: PingFang SC;
        font-weight: 400;
        margin: 16.5px 0 15px 230px;
    }
}
</style>
